import AddToPatientsModal from './add-to-patients-modal';

export default AddToPatientsModal;
